import { useTranslation } from "react-i18next";

export function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen grid place-items-center text-gray-500">
            {t("notFound")}
        </div>
    );
}
